import React, { useEffect, useState, useRef } from "react";
//i18n
import { withNamespaces } from "react-i18next";

import {
  Row,
  Col,
  Card,
  CardBody,
  Button,
  CardTitle,
  CardSubtitle,
  Container,
  Label,
  FormGroup,
  Spinner,
} from "reactstrap";

import { AvForm, AvField } from "availity-reactstrap-validation";
import BootstrapTable from "react-bootstrap-table-next";
import "../../../node_modules/react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
// Redux
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import TagsInput from "react-tagsinput";
import "react-tagsinput/react-tagsinput.css";
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import showNotification from "../../helpers/show_notification";
import { postSubmitForm } from "../../helpers/forms_helper";
import preloader from "../../helpers/preloader";
import ReactSelect from "react-select";

const AddVehicles = (props) => {

  useEffect(() => {
    loadAllVehicles();
    loadAllStores();
  }, []);

  const [allVehicles, setAllVehicles] = useState([]);
  const loadAllVehicles = async () => {
    preloader(true)
    let url = process.env.REACT_APP_BASEURL + "vehicles/getall";
    let response = await postSubmitForm(url, "");
    if (response.status === 1) {
      preloader(false)
      setAllVehicles(response.data);
    } else {
      preloader(false)
      // showNotification(response.message, "Error");
    }
  };

  const refContainer = useRef(null);
  const [selectedStores, setSelectedStores] = useState([]);

  const [allStores, setAllStores] = useState([]);
  const loadAllStores = async () => {
    preloader(true)
    let url = process.env.REACT_APP_BASEURL + "stores/getall";
    let response = await postSubmitForm(url, "");
    if (response.status === 1) {
      preloader(false)
      let branches = response.data.filter((ob) => ob.type === "Branch" || ob.type === "CENTRAL KITCHEN STORE")
      setAllStores(branches);
    } else {
      preloader(false)
      showNotification(response.message, "Error");
    }
  };
  const [isLoading, setIsLoading] = useState(false)
  const handleValidSubmit = async (e, v) => {
    try {
      if(selectedStores?.length===0){
        showNotification("Please select atleast one branch","Warning")
        return
      }
      let payload = {
        name: v.name,
        branches: selectedStores.map(store => ({ branch_id: store.value }))
      }
      setIsLoading(true)
      let url = process.env.REACT_APP_BASEURL + "vehicles/insert";
      let response = await postSubmitForm(url, payload);
      if (response.status === 1) {
        loadAllVehicles();
        setSelectedStores([])
        showNotification(response.message, "Success");
        refContainer.current.reset();
      } else {
        showNotification(response.message, "Error");
      }
    } catch (error) {
      showNotification(error.message, "Error");
    } finally {
      setIsLoading(false)
    }
  };

  const columns = [
    {
      dataField: "_id",
      hidden: true,
    },
    {
      dataField: "_id",
      formatter: (cell, row, rowIndex) => {
        return rowIndex + 1;
      },
      text: props.t("#"),
      headerStyle: (colum, colIndex) => {
        return { width: "3%" };
      },
    },
    {
      text: props.t("Vehicle/Driver"),
      dataField: "name",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      text: props.t("Branches"),
      sort: false,
      formatter: (cell, row) => {
        return (
          <>
            {row.branches.map((obj) => {
              return (
                <span class="font-size-12 mr-2 badge-soft-success badge badge-success badge-pill">
                  {obj.name}
                </span>
              );
            })}
          </>
        );
      },
      headerStyle: (colum, colIndex) => {
        return { width: "40%" };
      },
    },
  ];

  const customStyles = {
    multiValue: (base, state) => ({
      ...base,
      backgroundColor: "#daebc0",
      color: "#719639",
    }),
    multiValueLabel: (base, state) => ({
      ...base,
      color: "#719639",
    }),
  };

  
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs
            title={props.t("Vehicle/Driver")}
            breadcrumbItem={props.t("Add Vehicle/Driver")}
          />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <AvForm onValidSubmit={handleValidSubmit} ref={refContainer}>
                    <CardTitle>{props.t("Add Vehicle/Driver")}</CardTitle>
                    <CardSubtitle className="mb-3">
                      {props.t("Enter the following details to add a new vehicle/driver")}
                    </CardSubtitle>
                    <Row>
                      <Col lg={6} md={6}>
                        <AvField
                          name="name"
                          label={props.t("Vehicle/Driver")}
                          placeholder={props.t("Enter Vehicle/Driver Name")}
                          type="text"
                          validate={{
                            required: {
                              value: true,
                              errorMessage: props.t("cannot be empty"),
                            },
                          }}
                        />
                      </Col>
                      <Col lg={6} md={6}>
                        <Label>{props.t("Branches")}</Label>
                        <ReactSelect
                          isMulti
                          name="branches"
                          options={allStores}
                          
                          className="basic-multi-select"
                          classNamePrefix="select"
                          styles={customStyles}
                          value={selectedStores}
                          onChange={setSelectedStores}
                          placeholder={props.t("Select Branches...")}
                        />
                      </Col>


                      <Col lg={12}>
                        <hr />
                        <FormGroup className="mb-0 text-center">
                          <div>
                            <Button
                              type="submit"
                              color="primary"
                              disabled={isLoading}
                              style={{width:"100px"}}
                            >
                              {isLoading ? <Spinner size={"sm"} /> :props.t("Submit")}
                            </Button>
                          </div>
                        </FormGroup>
                      </Col>
                    </Row>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <CardTitle>{props.t("Existing Vehicles/Drivers")} </CardTitle>
                  <CardSubtitle className="mb-3">
                    {props.t("View all your existing vehicles/drivers here")}
                  </CardSubtitle>
                  <BootstrapTable
                    bootstrap4
                    keyField="_id"
                    data={allVehicles && allVehicles}
                    columns={columns}
                    noDataIndication={props.t("No data to display.")}
                    striped
                    hover
                    condensed
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(
  connect(null, {})(withNamespaces()(AddVehicles))
);
